// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".agreement[data-v-35ff9996]{text-align:center;font-size:1.1rem;color:var(--text-text-ternary);margin-bottom:.5rem}", ""]);
// Exports
module.exports = exports;
